module.exports = __webpack_public_path__ + "images/emoji/ice_cream.30ff3bace38ab82eed5a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ice_cream.png
// module id = UxJ/
// module chunks = 1